const getAllowedColumns = (columns, userRoles) =>
  columns.filter(({ allowedRoles }) =>
    userRoles?.some((role) => allowedRoles?.includes(role))
  );

export default getAllowedColumns;
